import React from "react";
import moment from "moment";
import clsx from "clsx";
import * as Icon from "react-feather";

import WComponent from "../common/WComponent";
import PlaybookRunService from "../../services/PlaybookRunService";
import UtilityService from "../../services/UtilityService";

import "./agent-run-outputs.css";

const OUTPUT_ICONS = {
	excel: Icon.Grid,
	powerpoint: Icon.Monitor,
	pdf: Icon.FileText,
	file: Icon.File,
};

class AgentRunOutputs extends WComponent {
	constructor(props) {
		super(props);
		this.state = {
			downloadingOutputId: null,
			downloadErrors: {},
		};
	}

	onDownload = async ({ output }) => {
		await this.update({ downloadingOutputId: output.id, downloadErrors: { ...this.state.downloadErrors, [output.id]: null } });
		try {
			await PlaybookRunService.downloadRunOutput({ output });
			await this.update({ downloadingOutputId: null });
		} catch (error) {
			const message = error.message || "The file could not be downloaded.";
			await this.update({ downloadingOutputId: null, downloadErrors: { ...this.state.downloadErrors, [output.id]: message } });
		}
	};

	renderOutput = output => {
		const { downloadingOutputId, downloadErrors } = this.state;
		const kind = PlaybookRunService.describeRunOutputKind({ kind: output.kind });
		const OutputIcon = OUTPUT_ICONS[kind.look];
		const isDownloading = downloadingOutputId === output.id;
		const downloadError = downloadErrors[output.id];
		const size = UtilityService.formatFileSize({ bytes: output.size });
		const meta = [kind.label, size, moment(output.createdAt).format("MMM D, h:mm a")].filter(Boolean).join(" · ");

		return (
			<div key={output.id} className="agent-run-outputs__row">
				<span className={clsx("agent-run-outputs__icon", `agent-run-outputs__icon--${kind.look}`)}>
					<OutputIcon size={16} />
				</span>
				<div className="agent-run-outputs__text">
					<span className="agent-run-outputs__title">{output.title}</span>
					<span className="agent-run-outputs__meta">
						{output.fileName} · {meta}
					</span>
					{kind.opensInGoogleSlides && (
						<span className="agent-run-outputs__hint">Opens in Google Slides: upload the .pptx to Drive or File → Open in Slides.</span>
					)}
					{downloadError && (
						<span className="agent-run-outputs__error">
							<span className="tk-dot tk-dot--danger" />
							{downloadError}
						</span>
					)}
				</div>
				<button
					type="button"
					className="tk-button tk-button--secondary tk-button--compact"
					onClick={() => this.onDownload({ output })}
					disabled={isDownloading}
				>
					<Icon.Download size={13} />
					{isDownloading ? "Downloading…" : "Download"}
				</button>
			</div>
		);
	};

	render() {
		const { outputs, loadError } = this.props;
		const hasOutputs = outputs && outputs.length > 0;
		if (!hasOutputs && !loadError) return null;

		return (
			<section className="agent-run-report__group">
				<div className="agent-run-report__group-head">
					<Icon.Package size={14} className="agent-run-report__group-icon" />
					<span className="agent-run-report__group-title">Outputs</span>
					{hasOutputs && <span className="agent-run-report__group-count">{outputs.length}</span>}
				</div>
				{loadError && (
					<div className="tk-notice tk-notice--warning">
						<div className="tk-notice__title">
							<Icon.AlertTriangle size={14} />
							{loadError}
						</div>
					</div>
				)}
				{hasOutputs && <div className="tk-card">{outputs.map(this.renderOutput)}</div>}
			</section>
		);
	}
}

export default AgentRunOutputs;
